module.exports = {"TXTWCL_SP":{"id":"TXTWCL_SP","defaultMessage":"SP"}}